import { render, staticRenderFns } from "./cabinet.vue?vue&type=template&id=7e2bdbb3&scoped=true"
import script from "./cabinet.vue?vue&type=script&lang=ts"
export * from "./cabinet.vue?vue&type=script&lang=ts"
import style0 from "./cabinet.vue?vue&type=style&index=0&id=7e2bdbb3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2bdbb3",
  null
  
)

export default component.exports